export default (Alpine) => {

	Alpine.data('dataFetcher', (defaultResponseObj = {}) => ({

		cssState: 'idle',
		response: defaultResponseObj,

		async _request(url, options = {}) {

			this.cssState = 'fetching';

			let finalUrl = url;
			let fetchOptions = {
				method: options.method || 'GET',
				headers: {

					'Content-Type': 'application/x-www-form-urlencoded'
					
				}
			};

			// Handle GET: params go into the URL
			if (fetchOptions.method === 'GET' && options.body) {

				const params = new URLSearchParams(options.body).toString();
				finalUrl = url.includes('?') ? `${url}&${params}` : `${url}?${params}`;

			} 
			
			// Handle POST: params go into the Body as a string
			if (fetchOptions.method !== 'GET' && options.body) {

				// This converts {id: 1} into "id=1"
				fetchOptions.body = new URLSearchParams(options.body).toString();

			}

			try {

				const res = await fetch(finalUrl, fetchOptions);

				const raw = await res.text();

				try {

					this.response = JSON.parse(raw);
					this.cssState = res.ok ? 'idle' : 'error';

				} catch (e) {

					console.error("Server Error/Non-JSON Response:", raw);
					this.cssState = 'error';

				}

			} catch (err) {

				this.cssState = 'error';
				console.error('Network Error:', err);

			}

		},
		async get(url, body = null) {

			return this._request(url, { method: 'GET', body: body });

		},
		async post(url, body) {

			return this._request(url, { method: 'POST', body: body });

		}

	}));

};